import { LineSkeletonStyled } from 'components/base/Skeletons';

const Loader = () => {
  return (
    <>
      <LineSkeletonStyled style={{ width: '100%', height: '3.5rem' }} />
    </>
  );
};

export default Loader;
